module.exports = __webpack_public_path__ + "img/hand-colored.3e8de71e.svg";